/**
 * Internal dependencies
 */
import { getExtraSegmentationInfo } from '../index';
import type { Attributes } from '../../../../../../packages/segmentation-rule-library/rules/browser/types';

export const type = 'nab/browser';

export function validate( attributes: Attributes ): boolean {
	const { condition, values } = attributes;

	const visitorBrowser = getExtraSegmentationInfo().browser;
	if ( 'string' !== typeof visitorBrowser ) {
		return false;
	}

	switch ( condition ) {
		case 'is-equal-to':
			return values.some( ( { value } ) =>
				isSameBrowser( value, visitorBrowser )
			);

		case 'is-not-equal-to':
			return values.every(
				( { value } ) => ! isSameBrowser( value, visitorBrowser )
			);
	}
}

function isSameBrowser( browserName: string, visitorBrowserName?: string ) {
	return browserName === visitorBrowserName;
}
